import {
    Box
} from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { Redirect } from 'react-router-dom';
import NotificationDeadlinesReminderTable from './components/NotificationDeadlinesReminderTable';
import { hasRole } from 'utils/auth-utils';

export default function Home() {

    const { keycloak } = useKeycloak();
    const isAdmin = hasRole(keycloak, 'admin') || hasRole(keycloak, 'ADMIN');

    // Employees don't get a separate home dashboard — "I miei Interventi" is their actual landing
    // page, so every way of reaching /dipendente/home (sidebar, breadcrumb, the post-login redirect)
    // forwards here instead, in this single place, rather than needing every link updated separately.
    if (!isAdmin) {
        return <Redirect to="/dipendente/interventi" />;
    }

    return (
        <Box pt={{ base: "40px", md: "80px", xl: "78px" }} px={4}>
            <NotificationDeadlinesReminderTable keycloak={keycloak}/>
        </Box>
    );
}